import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { getDateRange } from '../../../../utils/fix-uct-time';
import { toNaiveISO } from '../../../../utils/date';

import { IToast } from '../../../../interfaces/components/IToast';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { tryToFetchAllTeamMembers } from '../../../../store/brokers/partners/teams/teamsSlice';
import { tryToFetchFeedbacks, tryToUpdateFeedbackCategory, tryToUpdateFeedbackImportance, tryToUpdateFeedback } from '../../../../store/admin/feedbacks/feedbacksSlice';
import { tryToDeleteFeedback } from '../../../../store/admin/trips/feedbacksSlice';
import {
    tryToFetchAllJourneys,
    tryToFetchCabins,
    tryToFetchTrips,
    tryToFetchActiveTrips,
    tryToUpdateTripStatus,
    tryToDeleteTrip
} from '../../../../store/admin/trips/adminTripsSlice';
import ExportFeedbacksModal from '../modals/ExportFeedbacksModal';
import ExportTripsModal from '../modals/ExportTripsModal';
import TripDetailsModal from '../modals/TripDetailsModal';
import ManageTripsModal from '../modals/ManageTripsModal';
import MediaFeedback from '../modals/MediaFeedback';
import FeedbackDetailsModal from '../modals/FeedbackDetailsModal';
import ChangeStatusModal from '../modals/ChangeStatusModal';
import DeleteModal from '../../../../shared/delete-modal';
import FeedbacksTable from '../tables/FeedbacksTable';
import TripsTable from '../tables/TripsTable';
import TripDetailsFilters from '../components/TripDetailsFilter';
import TripFilters from '../components/TripFilters';
import Toast from '../../../../shared/toast';
import ReportsModal from '../../../../components/reports/ReportsModal';
import QualityReportModal from '../../../../components/reports/QualityReportModal';


const DetailedTab = () => {
    const dispatch = useAppDispatch();
    const [tripsData, setTripsData] = useState<any>();
    const [trainManagers, setTrainManagers] = useState<any>();
    const [staff, setStaff] = useState<any>();
    const [trips, setTrips] = useState<any>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 20,
    });
    // Infinite scroll state for feedbacks
    const [accumulatedFeedbacks, setAccumulatedFeedbacks] = useState<any[]>([]);
    const [feedbackHasMore, setFeedbackHasMore] = useState(true);
    const [feedbackLoadingMore, setFeedbackLoadingMore] = useState(false);
    const feedbackScrollRef = useRef<HTMLDivElement>(null);
    const loadingMoreRef = useRef(false);
    const [paginationStateTrips, setPaginationStateTrips] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    // Infinite scroll state for trips
    const [accumulatedTrips, setAccumulatedTrips] = useState<any[]>([]);
    const [tripsHasMore, setTripsHasMore] = useState(true);
    const [tripsLoadingMore, setTripsLoadingMore] = useState(false);
    const tripsScrollRef = useRef<HTMLDivElement>(null);
    const tripsLoadingMoreRef = useRef(false);
    const [showToast, setShowToast] = useState<IToast | null>();
    const [selectedTrip, setSelectedTrip] = useState<any>();
    const [selectedStaff, setSelectedStaff] = useState<any>();
    const [selectedStaffRole, setSelectedStaffRole] = useState<any>();
    const [selectedCabin, setSelectedCabin] = useState<string>('');
    const [selectedTrainManager, setSelectedTrainManager] = useState<any>();
    const [selectedDateRange, setSelectedDateRange] = useState<any>();
    const [tripDetailsModal, setTripDetailsModal] = useState<{ show: boolean, data: any }>()
    const [showNewTripModal, setShowNewTripModal] = useState<{ show: boolean, data?: any }>();
    const [selectedRag, setSelectedRag] = useState<any>();
    const [selectedDetailsJourneys, setSelectedDetailsJourneys] = useState<any>();
    const [selectedDetailsManager, setSelectedDetailsManager] = useState<any>();
    const [searchText, setSearchText] = useState<any>();
    const [mediaModal, setMediaModal] = useState<{ show: boolean, files: any }>();
    const [startDateRange, setStartDateRange] = useState<[Date, Date] | null>(null);
    const [endDateRange, setEndDateRange] = useState<[Date, Date] | null>(null);
    const [exportFeedbackModal, setExportFeedbackModal] = useState<boolean>(false);
    const [exportTripsModal, setExportTripsModal] = useState<boolean>(false)
    const [filterTypeSelected, setFilterTypeSelected] = useState<any>();
    const [cabins, setCabins] = useState<any>();
    const [feedbackDetailsModal, setFeedbackDetailsModal] = useState<{ show: boolean; data: any } | null>(null);
    const [isSavingFeedback, setIsSavingFeedback] = useState<boolean>(false);
    const [showFeedbackReport, setShowFeedbackReport] = useState<boolean>(false);
    const [reportsModal, setReportsModal] = useState<boolean>(false)
    const [changeStatusModal, setChangeStatusModal] = useState<{ show: boolean; trip: any } | null>(null);
    const [deleteModal, setDeleteModal] = useState<{ show: boolean; trip: any } | null>(null);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState<boolean>(false);
    const [isDeletingTrip, setIsDeletingTrip] = useState<boolean>(false);
    const dataTrip = useAppSelector(state => state.adminTrips.trips?.data)
    const paginationData = useAppSelector((state) => state.adminFeedbacks?.feedbacks?.data?.page);
    const paginationDataTrip = useAppSelector((state) => state.adminTrips?.trips?.data?.page);


    // const [feedbacks, setFeedbacks] = useState<any>();

    //   useEffect(() => {
    //     if (dataFeedback?.elements) {
    //         setFeedbacks(dataFeedback?.elements)
    //     }
    // }, [dataFeedback])

    const feedbacks = useAppSelector(state => state.adminFeedbacks.feedbacks?.data?.elements ?? []);


    const onResetPaginationStateTrips = () => {
        setPaginationStateTrips({
            pageNumber: 1,
            pageSize: paginationStateTrips?.pageSize || 10,
        })
    }

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }


    useEffect(() => {
        if (dataTrip?.elements) {
            setTripsData(dataTrip?.elements)
        }
    }, [dataTrip])

    // Keep accumulatedTrips in sync when tripsData updates from a fresh (non-loadMore) fetch
    useEffect(() => {
        if (tripsData && accumulatedTrips.length === 0) {
            setAccumulatedTrips(tripsData);
        }
    }, [tripsData])

    const onGettingData = async () => {
        try {
            const trainManagerRes = await dispatch(tryToFetchAllTeamMembers({ role: 'train_manager' })).unwrap();
            const formatTrainManagers = trainManagerRes && trainManagerRes?.length > 0 && trainManagerRes?.map((item: any) => {
                return {
                    ...item || {},
                    label: `${item?.name} ${item?.lastName}` || item?.username,
                    value: item?._id,
                }
            })
            setTrainManagers(formatTrainManagers)
            const journeysRes = await dispatch(tryToFetchAllJourneys()).unwrap();
            const formatJourneys = journeysRes?.elements && journeysRes?.elements?.length > 0 && journeysRes?.elements?.map((item: any) => {
                return {
                    ...item || {},
                    label: item?.journeyTitle,
                    value: item?._id,
                }
            })
            setTrips(formatJourneys || undefined)
            const staffRes = await dispatch(tryToFetchAllTeamMembers({ type: 'staff' })).unwrap();
            const formatStaff = staffRes && staffRes?.length > 0 && staffRes?.map((item: any) => {
                return {
                    ...item || {},
                    label: `${item?.name} ${item?.lastName}` || item?.username,
                    value: item?._id,
                }
            })
            setStaff(formatStaff)
        } catch (err) {
            console.error(err)
        }
    }

    const onPrepareMainFilters = () => {
        let settingsFilters: any = {}
        if (selectedTrip && selectedTrip?.value !== 'all') {
            settingsFilters = {
                ...settingsFilters || {},
                itinerary: selectedTrip?.value
            }
        }
        if (selectedDateRange) {
            const range = getDateRange([selectedDateRange?.[0], selectedDateRange?.[1]]);

            settingsFilters = {
                ...settingsFilters || {},
                startDate: range?.dateRangeMin,
                endDate: range?.dateRangeMax
            }
        }
        if (selectedTrainManager && selectedTrainManager?.value !== 'all') {
            settingsFilters = {
                ...settingsFilters || {},
                trainManagerId: selectedTrainManager?.value
            }
        }
        if (selectedStaff && selectedStaff?.value !== 'all') {
            settingsFilters = {
                ...settingsFilters || {},
                crewMemberId: selectedStaff?.value
            }
        }
        if (selectedStaffRole && selectedStaffRole?.value !== 'all') {
            settingsFilters = {
                ...settingsFilters || {},
                crewMemberRole: selectedStaffRole?.value
            }
        }
        if (selectedCabin?.trim()) {
            settingsFilters = {
                ...settingsFilters || {},
                cabinId: selectedCabin.trim().toUpperCase()
            }
        }
        if (filterTypeSelected?.type) {
            settingsFilters = {
                ...settingsFilters || {},
                type: filterTypeSelected?.type
            }
        }
        if (filterTypeSelected?.action) {
            settingsFilters = {
                ...settingsFilters || {},
                action: filterTypeSelected?.action === 'yes'
            }
        }
        if (filterTypeSelected?.sentiment) {
            settingsFilters = {
                ...settingsFilters || {},
                sentiment: filterTypeSelected?.sentiment
            }
        }
        if (filterTypeSelected?.category) {
            settingsFilters = {
                ...settingsFilters || {},
                category: filterTypeSelected?.category
            }
        }
        if (filterTypeSelected?.subCategory) {
            settingsFilters = {
                ...settingsFilters || {},
                subCategory: filterTypeSelected?.subCategory
            }
        }
        if (filterTypeSelected?.importance) {
            settingsFilters = {
                ...settingsFilters || {},
                importance: filterTypeSelected?.importance
            }
        }
        return settingsFilters
    }

    const onPrepareDetailsFilters = () => {
        let formatData: any
        if (searchText) {
            formatData = {
                ...formatData || {},
                filters: searchText
            }
        }
        if (selectedRag && selectedRag?.value !== 'all') {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    status: selectedRag?.value
                }
            }
        }
        if (selectedDetailsManager && selectedDetailsManager?.value !== 'all') {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    trainManagerId: selectedDetailsManager?.value
                }
            }
        }
        if (selectedDetailsJourneys && selectedDetailsJourneys?.value !== 'all') {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    itineraryId: selectedDetailsJourneys?.value
                }
            }
        }
        if (startDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    startDateMin: toNaiveISO(startDateRange?.[0]),
                    startDateMax: toNaiveISO(startDateRange?.[1])
                }
            }
        }
        if (endDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    endDateMin: toNaiveISO(endDateRange?.[0]),
                    endDateMax: toNaiveISO(endDateRange?.[1])
                }
            }
        }
        return formatData
    }

    const onGettingTrips = async (isLoadMore = false) => {
        try {
            if (isLoadMore) {
                setTripsLoadingMore(true);
                tripsLoadingMoreRef.current = true;
            }
            const pageNum = isLoadMore ? paginationStateTrips.pageNumber : 1;
            const formatData: any = {
                pageNumber: pageNum,
                pageSize: paginationStateTrips.pageSize || 10,
                ...onPrepareDetailsFilters() || {}
            }
            const result = await dispatch(tryToFetchTrips(formatData)).unwrap();
            const newElements = result?.data?.elements ?? [];
            const pageInfo = result?.data?.page;

            if (isLoadMore) {
                setAccumulatedTrips(prev => [...prev, ...newElements]);
            } else {
                setAccumulatedTrips(newElements);
            }

            const hasNext = pageInfo?.hasNextPage ?? false;
            setTripsHasMore(hasNext);
        } catch (err) {
            console.error(err)
        } finally {
            if (isLoadMore) {
                setTripsLoadingMore(false);
                tripsLoadingMoreRef.current = false;
            }
        }
    }

    const onLoadMoreTrips = () => {
        if (tripsLoadingMoreRef.current || !tripsHasMore) return;
        setPaginationStateTrips(prev => ({
            ...prev,
            pageNumber: (prev.pageNumber || 1) + 1,
        }));
    }

    const onGettingFeedbacks = useCallback(async (isLoadMore = false) => {
        try {
            if (isLoadMore) {
                setFeedbackLoadingMore(true);
                loadingMoreRef.current = true;
            }
            const pageNum = isLoadMore ? paginationState.pageNumber : 1;
            const formatData: any = {
                pageNumber: pageNum,
                pageSize: paginationState.pageSize || 20,
                data: onPrepareMainFilters() || {}
            }
            const result = await dispatch(tryToFetchFeedbacks(formatData)).unwrap();
            const newElements = result?.data?.elements ?? [];
            const pageInfo = result?.data?.page;

            if (isLoadMore) {
                setAccumulatedFeedbacks(prev => [...prev, ...newElements]);
            } else {
                setAccumulatedFeedbacks(newElements);
            }

            const hasNext = pageInfo?.hasNextPage ?? false;
            setFeedbackHasMore(hasNext);

            if (isLoadMore) {
                setFeedbackLoadingMore(false);
                loadingMoreRef.current = false;
            }
        } catch (err) {
            console.error(err);
            if (isLoadMore) {
                setFeedbackLoadingMore(false);
                loadingMoreRef.current = false;
            }
        }
    }, [paginationState, selectedTrip, selectedDateRange, selectedTrainManager, selectedStaff, selectedStaffRole, selectedCabin, filterTypeSelected]);

    const onGettingCabins = async () => {
        try {
            const response = await dispatch(tryToFetchCabins()).unwrap();
            const formatCabins = response && response?.length > 0 && response?.map((item: any) => {
                return {
                    ...item || {},
                    label: item?.name || `${item?.type} ${item?.cabinId}`,
                    value: item?.cabinId,
                }
            })
            setCabins(formatCabins)
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingData()
        onGettingTrips()
        onGettingFeedbacks()
        onGettingCabins()
    }, [])

    const onChangeDateRange = (value: any) => {
        setSelectedDateRange(value)
    }

    const onClickTrip = (type: string, data?: any) => {
        if (type === 'new') {
            setShowNewTripModal({
                show: true,
                data: data
            })
        }
    }

    const onChangeFilters = (value: any, type?: string) => {
        if (type === 'journey') setSelectedTrip(value);
        if (type === 'trainManager') setSelectedTrainManager(value);
        if (type === 'staff') setSelectedStaff(value);
        if (type === 'staffRole') setSelectedStaffRole(value);
        if (type === 'cabin') {
            const normalizedCabin = (value || '').toString().replace(/\s+/g, '').toUpperCase();
            setSelectedCabin(normalizedCabin);
        }
        // Reset for infinite scroll
        setAccumulatedFeedbacks([]);
        setFeedbackHasMore(true);
        setPaginationState(prev => ({ ...prev, pageNumber: 1 }));
    };

    const onEditTrip = (data: any) => {
        setShowNewTripModal({
            show: true,
            data: data
        })
    }

    const onCloseTripModal = () => {
        setShowNewTripModal(undefined)
    }

    // Load initial feedbacks when filters change
    useEffect(() => {
        setPaginationState(prev => ({ ...prev, pageNumber: 1 }));
        onGettingFeedbacks(false);
    }, [selectedTrip, selectedDateRange, selectedTrainManager, selectedStaff, selectedStaffRole, selectedCabin, filterTypeSelected]);

    const onLoadMoreFeedbacks = useCallback(() => {
        if (loadingMoreRef.current || !feedbackHasMore) return;
        setPaginationState(prev => {
            const nextPage = (prev.pageNumber || 1) + 1;
            return { ...prev, pageNumber: nextPage };
        });
    }, [feedbackHasMore]);

    // When pagination page changes (for load more), fetch next page
    useEffect(() => {
        if (paginationState.pageNumber > 1) {
            onGettingFeedbacks(true);
        }
    }, [paginationState.pageNumber]);

    useEffect(() => {
        if (paginationStateTrips.pageNumber > 1) {
            onGettingTrips(true);
        } else {
            onGettingTrips(false);
        }
    }, [paginationStateTrips]);

    const onClickClearAll = () => {
        setSelectedDateRange(undefined)
        setSelectedStaff(undefined)
        setSelectedTrainManager(undefined)
        setSelectedTrip(undefined)
        setSelectedCabin('')
        setAccumulatedFeedbacks([]);
        setFeedbackHasMore(true);
        setSelectedStaffRole(undefined)
        onResetPaginationState()
    }

    const onResetFilters = () => {
        setStartDateRange(null);
        setEndDateRange(null);
        setSearchText(undefined);
        setSelectedDetailsJourneys(undefined)
        setSelectedDetailsManager(undefined)
        setSelectedRag(undefined)
        setAccumulatedTrips([]);
        setTripsHasMore(true);
        onResetPaginationStateTrips();
    };

    const onChangeSearchValue = (e: any) => {
        setSearchText(e)
        setAccumulatedTrips([]);
        setTripsHasMore(true);
        onResetPaginationStateTrips();
    }

    const onChangeEndTripsDate = (value: any) => {
        setEndDateRange(value)
        setAccumulatedTrips([]);
        setTripsHasMore(true);
        onResetPaginationStateTrips()
    }

    const onChangeStartTripsDate = (value: any) => {
        setStartDateRange(value)
        setAccumulatedTrips([]);
        setTripsHasMore(true);
        onResetPaginationStateTrips()
    }

    const onChangeSelectedFilter = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'rag':
                    setSelectedRag(value);
                    break;
                case 'trainManagers':
                    setSelectedDetailsManager(value)
                    break;
                case 'journeys':
                    setSelectedDetailsJourneys(value)
                    break;
            }
            onResetPaginationStateTrips();
        }
    }

    const onClickFeedbacksModal = () => {
        setExportFeedbackModal(!exportFeedbackModal)
    }

    const onClickTripsModal = () => {
        setExportTripsModal(!exportTripsModal)
    }

    const onClickTripDetails = (data: any) => {
        setTripDetailsModal({
            show: true,
            data: data
        })
    }

    const refreshAllData = () => {
        onGettingTrips();
        setAccumulatedFeedbacks([]);
        setFeedbackHasMore(true);
        setPaginationState(prev => ({ ...prev, pageNumber: 1 }));
        onGettingFeedbacks(false);
        dispatch(tryToFetchActiveTrips({ pageNumber: 1, pageSize: 10, data: { status: 'active' } }));
    };

    const onSaveSuccessfulTrip = (message: string) => {
        setShowToast({ type: 'success', message: message });
        refreshAllData();
        onCloseTripModal();
    }

    const handleFilterTypeChange = (type: string, name: string) => {
        const newType = filterTypeSelected?.[name] === type ? undefined : type
        setFilterTypeSelected((prev: any) => ({
            ...prev || {},
            [name]: newType
        }))
        // Reset for infinite scroll
        setAccumulatedFeedbacks([]);
        setFeedbackHasMore(true);
        setPaginationState(prev => ({ ...prev, pageNumber: 1 }));
    };

    const onClickOpenMediaModal = (files: any) => {
        setMediaModal({
            show: true,
            files: files
        })
    }

    const onClickShowReports = () => {
        setReportsModal(!reportsModal)
    }

    const onClickFeedbackRow = (feedback: any) => {
        setFeedbackDetailsModal({ show: true, data: feedback });
    };

    const onCloseFeedbackDetails = () => {
        setFeedbackDetailsModal(null);
    };

    const onSaveFeedbackDetails = async (id: string, payload: Record<string, any>) => {
        setIsSavingFeedback(true);
        try {
            await dispatch(tryToUpdateFeedback({ id, payload })).unwrap();
            // Update the local accumulated feedbacks list
            setAccumulatedFeedbacks((prev) =>
                prev.map((f: any) => {
                    if (f._id !== id) return f;

                    /* Compute updated files list */
                    let updatedFiles = [...(f.files || f.additionalInfo?.files || [])];
                    if (payload.removeFiles?.length) {
                        updatedFiles = updatedFiles.filter(
                            (file: any) => !payload.removeFiles.includes(file.url),
                        );
                    }
                    if (payload.addFiles?.length) {
                        updatedFiles = [...updatedFiles, ...payload.addFiles];
                    }

                    return {
                        ...f,
                        ...payload.description !== undefined ? { description: payload.description } : {},
                        ...payload.action !== undefined ? { action: payload.action } : {},
                        ...payload.actionStatus !== undefined ? { actionStatus: payload.actionStatus } : {},
                        ...payload.personResponsibleForAction !== undefined ? { personResponsibleForAction: payload.personResponsibleForAction } : {},
                        ...(payload.removeFiles || payload.addFiles) ? { files: updatedFiles } : {},
                        additionalInfo: {
                            ...(f.additionalInfo || {}),
                            ...payload.description !== undefined ? { description: payload.description } : {},
                            ...payload.category !== undefined ? { category: payload.category } : {},
                            ...payload.subCategory !== undefined ? { subCategory: payload.subCategory } : {},
                            ...payload.sentiment !== undefined ? { sentiment: payload.sentiment } : {},
                            ...payload.importance !== undefined ? { importance: payload.importance } : {},
                            ...payload.cabinId !== undefined ? { cabinId: payload.cabinId, cabin: payload.cabin } : {},
                            ...(payload.removeFiles || payload.addFiles) ? { files: updatedFiles } : {},
                        },
                    };
                }),
            );
            setShowToast({ type: 'success', message: 'Feedback updated successfully' });
            onCloseFeedbackDetails();
            onGettingTrips();
        } catch (error: any) {
            setIsSavingFeedback(false);
            /* Re-throw so the modal can display the error inline */
            throw error;
        } finally {
            setIsSavingFeedback(false);
        }
    };

    const onDeleteFeedback = async (id: string) => {
        await dispatch(tryToDeleteFeedback({ id })).unwrap();
        setAccumulatedFeedbacks((prev) => prev.filter((f: any) => f._id !== id));
        setShowToast({ type: 'success', message: 'Feedback deleted successfully' });
        onGettingTrips();
    };

    const onClickChangeStatus = (trip: any) => {
        setChangeStatusModal({
            show: true,
            trip: trip
        });
    }

    const onClickDelete = (trip: any) => {
        setDeleteModal({
            show: true,
            trip: trip
        });
    }

    const handleStatusUpdate = async (status: string) => {
        if (!changeStatusModal?.trip?._id) return;

        setIsUpdatingStatus(true);
        try {
            await dispatch(tryToUpdateTripStatus({
                id: changeStatusModal.trip._id,
                status: status
            })).unwrap();

            setShowToast({ type: 'success', message: 'Trip status updated successfully' });
            setChangeStatusModal(null);
            refreshAllData();
        } catch (error: any) {
            setShowToast({ type: 'error', message: error || 'Failed to update trip status' });
        } finally {
            setIsUpdatingStatus(false);
        }
    }

    const handleDeleteTrip = async () => {
        if (!deleteModal?.trip?._id) return;

        setIsDeletingTrip(true);
        try {
            await dispatch(tryToDeleteTrip(deleteModal.trip._id)).unwrap();

            setShowToast({ type: 'success', message: 'Trip deleted successfully' });
            setDeleteModal(null);
            refreshAllData();
        } catch (error: any) {
            setShowToast({ type: 'error', message: error || 'Failed to delete trip' });
        } finally {
            setIsDeletingTrip(false);
        }
    }

    return (
        <div>
            <h2 className='text-xl font-bold text-gray-900 dark:text-white mb-4 mt-6'>Feedback</h2>
            <TripFilters
                allTrips={trips}
                trainManagers={trainManagers}
                staff={staff}
                selectedDateRange={selectedDateRange}
                selectedStaff={selectedStaff}
                selectedStaffRole={selectedStaffRole}
                selectedCabin={selectedCabin}
                selectedTrainManager={selectedTrainManager}
                selectedTrip={selectedTrip}
                onChangeDateRange={onChangeDateRange}
                onChangeFilters={onChangeFilters}
                onChangeCabin={(value) => onChangeFilters(value, 'cabin')}
                onClickTrip={onClickTrip}
                onClickClearAll={onClickClearAll}
                title='Feedback Filters'
                hideActions
            />
            <div className='my-5'>
                <FeedbacksTable
                    rows={accumulatedFeedbacks}
                    filterTypeSelected={filterTypeSelected}
                    totalCount={paginationData?.totalElements ?? accumulatedFeedbacks.length}
                    hasMore={feedbackHasMore}
                    loadingMore={feedbackLoadingMore}
                    scrollContainerRef={feedbackScrollRef as React.RefObject<HTMLDivElement>}
                    openMediaModal={onClickOpenMediaModal}
                    handleFilterTypeChange={handleFilterTypeChange}
                    onLoadMore={onLoadMoreFeedbacks}
                    onRowClick={onClickFeedbackRow}
                    onFeedbackReport={() => setShowFeedbackReport(true)}
                    onExportData={onClickFeedbacksModal}
                    journeys={trips}
                    selectedJourney={selectedTrip}
                    onJourneyFilterChange={(value) => onChangeFilters(value, 'journey')}
                    onUpdateFeedbackCategory={async (id, payload) => {
                        await dispatch(
                            tryToUpdateFeedbackCategory({
                                id,
                                payload: {
                                    category: payload.category ?? null,
                                    subCategory: payload.subCategory ?? null,
                                },
                            }),
                        ).unwrap();
                    }}
                    onUpdateFeedbackImportance={async (id, importance, originalImportance) => {
                        await dispatch(
                            tryToUpdateFeedbackImportance({
                                id,
                                importance,
                                originalImportance,
                            }),
                        ).unwrap();
                    }}
                />
            </div>
            <div className='mb-5 mt-10'>
                <p className='text-xl font-bold text-gray-900 dark:text-white mb-4 mt-6'>Trip Management</p>
                <TripDetailsFilters
                    journeys={trips}
                    trainManagers={trainManagers}
                    searchText={searchText}
                    selectedDetailsJourneys={selectedDetailsJourneys}
                    selectedDetailsManager={selectedDetailsManager}
                    selectedRag={selectedRag}
                    startDateRange={startDateRange}
                    endDateRange={endDateRange}
                    onChangeEndTripsDate={onChangeEndTripsDate}
                    onChangeStartTripsDate={onChangeStartTripsDate}
                    onChangeSearchValue={onChangeSearchValue}
                    onResetFilters={onResetFilters}
                    onChangeSelectedFilter={onChangeSelectedFilter}
                />
                <TripsTable
                    rows={accumulatedTrips}
                    totalCount={paginationDataTrip?.totalElements}
                    hasMore={tripsHasMore}
                    loadingMore={tripsLoadingMore}
                    onClickTripDetails={onClickTripDetails}
                    onClickEditTrip={onEditTrip}
                    onClickChangeStatus={onClickChangeStatus}
                    onClickDelete={onClickDelete}
                    onLoadMore={onLoadMoreTrips}
                    onExportData={onClickTripsModal}
                    scrollContainerRef={tripsScrollRef}
                />
            </div>
            {showNewTripModal?.show &&
                <ManageTripsModal
                    open={showNewTripModal?.show}
                    journeys={trips}
                    data={showNewTripModal?.data}
                    onSaveSuccessful={onSaveSuccessfulTrip}
                    onClose={onCloseTripModal}
                />
            }
            {exportFeedbackModal &&
                <ExportFeedbacksModal
                    openModal={exportFeedbackModal}
                    data={feedbacks}
                    totalCount={paginationData?.totalElements ?? feedbacks.length}
                    handleCloseModal={onClickFeedbacksModal}
                    onGettingFilters={onPrepareMainFilters}
                />
            }
            {exportTripsModal &&
                <ExportTripsModal
                    openModal={exportTripsModal}
                    data={tripsData}
                    handleCloseModal={onClickTripsModal}
                    onGettingFilters={onPrepareDetailsFilters}
                />
            }
            {tripDetailsModal?.show &&
                <TripDetailsModal
                    open={tripDetailsModal?.show}
                    data={tripDetailsModal?.data}
                    cabins={cabins}
                    onClose={() => setTripDetailsModal(undefined)}
                    onDataChanged={refreshAllData}
                />
            }
            {feedbackDetailsModal?.show &&
                <FeedbackDetailsModal
                    open={feedbackDetailsModal.show}
                    feedback={feedbackDetailsModal.data}
                    onClose={onCloseFeedbackDetails}
                    onSave={onSaveFeedbackDetails}
                    onDelete={onDeleteFeedback}
                    isSaving={isSavingFeedback}
                />
            }
            {mediaModal?.show &&
                <MediaFeedback
                    openModal={mediaModal?.show}
                    files={mediaModal?.files}
                    handleClose={() => setMediaModal(undefined)}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
            {reportsModal &&
                <ReportsModal
                    open={reportsModal}
                    onClose={onClickShowReports}
                />
            }
            {showFeedbackReport &&
                <QualityReportModal
                    open={showFeedbackReport}
                    trainManagers={trainManagers}
                    staff={staff}
                    trips={trips}
                    onClose={() => setShowFeedbackReport(false)}
                />
            }
            {changeStatusModal?.show &&
                <ChangeStatusModal
                    open={changeStatusModal.show}
                    currentStatus={changeStatusModal.trip?.status}
                    onClose={() => setChangeStatusModal(null)}
                    onConfirm={handleStatusUpdate}
                    isLoading={isUpdatingStatus}
                />
            }
            {deleteModal?.show &&
                <DeleteModal
                    openDeleteModal={deleteModal.show}
                    handleCloseDeleteModal={() => setDeleteModal(null)}
                    onApproveDeletion={handleDeleteTrip}
                    title="Delete Trip"
                    message="You are about to delete this trip. This will also delete all feedback gathered on the trip."
                    isLoading={isDeletingTrip}
                />
            }
        </div>
    )
}

export default DetailedTab;